import request from '@/utils/request';

//微信二维码
export function wechatCode(params) {
    return request({
        method: 'get',
        url: 'wechat/code',
		params
    })
}

//微信登录
export function userScanLogin(data) {
    return request({
        method: 'post',
        url: 'user/scanLogin',
		data:data
    })
}

//短信验证码
export function smsSend(data) {
    return request({
        method: 'post',
        url: 'sms/send',
		data:data
    })
}

//手机号登录
export function userMobileLogin(data) {
    return request({
        method: 'post',
        url: 'user/mobileLogin',
		data:data
    })
}

//获取网站配置
export function indexConfig(params) {
    return request({
        method: 'post',
        url: 'index/config',
		params
    })
}

export function userMpCodeLogin(params) {
    return request({
        method: 'get',
        url: 'user/mpCodeLogin',
		params
    })
}
